import '@/styles/a11y.css';
import '@/services/interpreter';
import '@/services/interpreter-override';
import userStateModule from '@cm-frontend/commons/user-state-module';
import CodementumNavbarPlugin from '@cm-frontend/panel-navbar';
import axios from 'axios';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import App from '@/App.vue';
import i18n from '@/locales';
import EventBus from '@/plugin/vue-event-bus';
import router from '@/router';
import store from '@/store/index';
import Locale from '@/utils/locale';
import PageUtils from '@/utils/page-utils';

import { globalMixin } from './mixins/global';

if (PageUtils.isLocalhost()) {
  /**
   * for local show
   * studioType = 'studio' | 'studioevent'
   * studioAssetType = 'game'
   *
   *
   * studioType = 'studio2' | 'studioevent2'
   * studioAssetType = 'game2'
   */
  window.isDevelopment = true;
  window.studioType = 'studio2';
  window.studioAssetType = window.studioType.includes('2') ? 'game2' : 'game';
}

Vue.use(VueI18n);
Vue.options.i18n = new VueI18n({
  locale: 'en',
  messages: i18n
});

Vue.use(EventBus);
Vue.use(CodementumNavbarPlugin, {
  i18n,
  store,
  axios,
  storeMerge: {
    modules: {
      state: userStateModule()
    }
  },
  mode: import.meta.env.MODE,
  pkgVersion: import.meta.env.PKG_VERSION
});

Vue.mixin(globalMixin);

const instance = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

Locale.use(instance);

window.__GAMES = [];
window.$vue = instance;

// import * as Sentry from '@sentry/vue';
// Sentry.init({
//   app: [instance],
//   dsn: isProduction
//     ? 'https://d2c5cdad5e02988f94793b8d55429aea@o4506588833775616.ingest.sentry.io/4506588841639936'
//     : '',
//   integrations: [new Sentry.browserTracingIntegration()],
//   debug: !isProduction,
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions,
//   ignoreErrors: [
//     /^Unexpected token(.*)/,
//     /^general(.*)/,
//     /^(?!ՐՏ).*is not defined.*/,
//     'Inconsistent indentation',
//   ],
// });
